import React, { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import type { GalleryItem } from '../types/content';
type AutoGalleryProps = {
  items: GalleryItem[];
  label: string;
  className?: string;
  /** Scrollsnelheid in pixels per seconde. */
  speed?: number;
};
const slideClass = 'shrink-0 h-[180px] w-[180px] sm:h-[220px] sm:w-[220px] overflow-hidden rounded-[20px] bg-blush';
export function AutoGallery({
  items,
  label,
  className = 'bg-lilac',
  speed = 45
}: AutoGalleryProps) {
  const reduceMotion = useReducedMotion();
  const setRef = useRef<HTMLUListElement>(null);
  const [duration, setDuration] = useState(45);
  useEffect(() => {
    const el = setRef.current;
    if (!el) return;
    const update = () => {
      // Larghezza di un set completo (gap incluso tramite padding-right) ÷ velocità.
      const width = el.getBoundingClientRect().width;
      if (width > 0) setDuration(width / speed);
    };
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => observer.disconnect();
  }, [speed, reduceMotion]);
  const renderSlides = (hidden: boolean) => items.map(item => <li key={`${hidden ? 'clone-' : ''}${item.id}`} className={slideClass} data-id="element-19" data-mp="2dm7mltt684gr">
        <img src={item.src} alt={hidden ? '' : item.alt} loading="lazy" decoding="async" draggable={false} className="h-full w-full object-cover" data-id="element-20" data-mp="2dk38kj1k5p2r" />
      </li>);
  if (reduceMotion) {
    return <section aria-label={label} className={`py-8 sm:py-10 ${className}`} data-id="element-21" data-mp="2nij1mrk5b8ew">
        <ul tabIndex={0} aria-label={label} className="max-w-6xl mx-auto flex gap-[22px] overflow-x-auto snap-x px-5 sm:px-8 no-scrollbar" data-id="element-22" data-mp="2ik92k5vavno0">
          {renderSlides(false)}
        </ul>
      </section>;
  }
  return <section aria-label={label} className={`overflow-hidden py-8 sm:py-10 ${className}`} data-id="element-23" data-mp="2sceuxgpgs73q">
      <div className="marquee-track flex" style={{
      '--marquee-duration': `${duration}s`
    } as React.CSSProperties} data-id="element-24" data-mp="36bwmg3u59ygs">
        <ul ref={setRef} className="flex gap-[22px] pr-[22px]" aria-label={label} data-id="element-25" data-mp="31dlfc0v8i229">
          {renderSlides(false)}
        </ul>
        <ul className="flex gap-[22px] pr-[22px]" aria-hidden="true" data-id="element-26" data-mp="23xgq6nr43xb0">
          {renderSlides(true)}
        </ul>
      </div>
    </section>;
}